import { render } from "./EstimateDetailBefore.vue?vue&type=template&id=63ef06c0"
import script from "./EstimateDetailBefore.vue?vue&type=script&lang=js"
export * from "./EstimateDetailBefore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/EstimateDetailBefore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63ef06c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63ef06c0', __exports__)) {
    api.reload('63ef06c0', __exports__)
  }
  
  module.hot.accept("./EstimateDetailBefore.vue?vue&type=template&id=63ef06c0", () => {
    api.rerender('63ef06c0', render)
  })

}


export default __exports__